import { Entity, Field } from "typegraph";
import ProgramProgress from "./ProgramProgress";
import ProgramTrackProduct from "./ProgramTrackProduct";


@Entity({one: "programTrack", many: "programTracks"})
export default class ProgramTrack {

	@Field()
	public id: number;

	@Field()
	public name: string;

	@Field()
	public description?: string;

	@Field()
	public trackIconURL?: string;

	@Field({entity: ProgramProgress})
	public progress?: ProgramProgress;

	@Field({entity: ProgramTrackProduct})
	public products?: ProgramTrackProduct[];

}



// WEBPACK FOOTER //
// ./src/panels/program/entities/ProgramTrack.ts